import { computed } from 'vue';
import useSortAndFilter from './useSortAndFilter';

export default function useMultiSelectButtons(props) {
  const {
    clearAllSelectedFacets,
    applyFilter,
    isFacetsLoading,
    allSingleSelectedFacets,
    rightSideDrawer,
    formattedSlideoutProductCount,
    isMobileInLandscape,
    isMobile,
    globalOptions: { isDynamicFilters },
    applyFilterDynamic,
  } = useSortAndFilter(props);

  const isFacetDropdown = computed(() => !isMobileInLandscape.value && !isMobile.value);
  const buttonsGap = computed(() => (isFacetDropdown.value ? '64px' : '40px'));
  const buttonHeight = computed(() => (isFacetDropdown.value ? '40px' : '50px'));
  const buttonWrapper = computed(() => (!isFacetDropdown.value ? 'button-wrapper' : ''));
  const buttonWrapperHeight = computed(() => (isFacetDropdown.value || props.facet.parent === 'Size' ? 'button-wrapper-height' : ''));
  const buttonWrapperPaddingSize = computed(() => (!isFacetDropdown.value && props.facet.parent === 'Size' ? 'button-wrapper-size' : ''));
  const isClearAllDisabled = computed(() => {
    const selectedValues = Array.isArray(props.facet.allSelectedValues) ? props.facet.allSelectedValues : props.facet.selectedValues;
    return !selectedValues.length || isFacetsLoading.value;
  });

  const numberOfSelected = computed(() => {
    if (isDynamicFilters.value) {
      // use parent facet if exists
      return (props.parentFacet || props.facet).selectedValues.length || '';
    }

    return allSingleSelectedFacets?.selectedValues?.length || '';
  });

  return {
    clearAllSelectedFacets,
    applyFilter,
    allSingleSelectedFacets,
    rightSideDrawer,
    formattedSlideoutProductCount,
    isFacetDropdown,
    isClearAllDisabled,
    buttonsGap,
    buttonHeight,
    buttonWrapper,
    buttonWrapperHeight,
    buttonWrapperPaddingSize,
    isDynamicFilters,
    numberOfSelected,
    applyFilterDynamic,
  };
}
